module.exports = __webpack_public_path__ + "img/auth_image.66e8e263.svg";